import React from 'react';
import { Link } from 'react-router-dom';
import { MatterDetailed } from '../../../../types/matters';

interface DocumentsTabProps {
  matter: MatterDetailed;
}

const DocumentsTab: React.FC<DocumentsTabProps> = ({ matter }) => {
  return (
    <div className="space-y-6">
      <div className="rounded-lg border border-gray-200 bg-white p-6 dark:border-gray-700 dark:bg-gray-800">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white">Documents</h3>
          <Link
            to={`/documents?engagementId=${encodeURIComponent(matter.id)}`}
            className="inline-flex items-center rounded-md bg-lex-accent px-3 py-2 text-sm font-medium text-lex-accent-contrast transition-colors hover:bg-lex-accent-hover"
          >
            Open Documents Workspace
          </Link>
        </div>
        <p className="mt-3 max-w-2xl text-sm text-gray-600 dark:text-gray-300">
          Engagement documents are managed in the shared Documents workspace while deeper WeBeDocs frontend wiring is completed.
        </p>
      </div>
    </div>
  );
};

export default DocumentsTab;
